import React from 'react';

import { useSelector } from 'react-redux';

import { FeatureTransportLines } from '../components/SelectedFeature/FeatureTransportLine';
import { FeaturePathLine } from '../components/SelectedFeature/FeaturePathLine';
import { FeaturePathGraph } from '../components/SelectedFeature/FeaturePathGraph';
import { FeaturePoi } from './FeaturePoi';

export const FeatureSelectedInfo = ({layer_id, feature}) => {

  const baseGraph = useSelector(state => state.map.activeBaseGraphe);
  
  const renderComponent = () => {
    if (layer_id === 'lignes_transports' || layer_id === 'lignes_transports_symbols') {
      return (
        <FeatureTransportLines features={feature} layer_id={layer_id}/>
      );
    }
    if (layer_id === 'selectedpath_bus_line' || layer_id === 'selectedpath_line') {
      return (
        <FeaturePathLine feature={feature}/>
      );
    }
    if (layer_id === baseGraph) {
      return (
        <FeaturePathGraph feature={feature}/>
      );
    } else {
      return (
        <FeaturePoi feature={feature} layer_id={layer_id} />
      );
    }
  };
  return (
    <>
      {renderComponent()}
    </>
  );
};
